import {ChangeEvent, FC, useContext, useEffect, useRef, useState} from 'react';
import {useSetRecoilState} from 'recoil';

import LoadingButton from '@mui/lab/LoadingButton';
import {Box, Paper, Stack, Tooltip, Typography} from '@mui/material';
import DocIconSwitcher from '../../../ui/doc-icon-switcher/DocIconSwitcher';
import {ImportDevicesTable} from './ImportDevicesTable';

import {useFileUpload} from '../../../hooks/useFileUpload';

import {DocumentService} from '../../../api/services/document.service';

import {EventBusContext} from '../../../providers/EventBus';

import {importOfDevicesQueryTrigger} from '../../../store/service-request-imports/atoms';

export const ImportDevices: FC = () => {
  const [loading, setLoading] = useState(false);
  const {files, fileNames, setFiles, clearAllFiles} = useFileUpload();
  const triggerQuery = useSetRecoilState(importOfDevicesQueryTrigger);
  const inputRef = useRef<HTMLInputElement>(null);
  const {bus} = useContext(EventBusContext);

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    clearAllFiles();
    setFiles(e);
  };

  useEffect(() => {
    return () => clearAllFiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!loading && files[0] && fileNames[0]) {
      const formData = new FormData();

      formData.append('docFile', files[0]);

      setLoading(true);
      DocumentService.importDevices(formData)
        .then(() => triggerQuery((v) => v + 1))
        .catch((e) => bus?.emit('error', [e]))
        .finally(() => setLoading(false));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files, fileNames]);

  return (
    <Box sx={{margin: '30px'}}>
      <Stack direction="row" spacing={2} sx={{mb: 3}}>
        <LoadingButton variant="contained" onClick={() => inputRef?.current?.click()} loading={loading}>
          Импорт
        </LoadingButton>
        <Stack direction="row" alignItems="center" spacing={1}>
          {fileNames[0] && (
            <>
              <DocIconSwitcher docName={fileNames[0]} />
              <Box sx={{maxWidth: '385px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                <Tooltip placement="bottom-start" title={fileNames[0]}>
                  <Typography noWrap textOverflow="ellipsis">
                    {fileNames[0]}
                  </Typography>
                </Tooltip>
              </Box>
            </>
          )}
        </Stack>
      </Stack>
      <input type="file" ref={inputRef} accept=".xls,.xlsx" style={{display: 'none'}} onChange={onChange} />
      <Paper>
        <ImportDevicesTable />
      </Paper>
    </Box>
  );
};
